import { render, staticRenderFns } from "./ConfirmationComponent.vue?vue&type=template&id=343fd0b6&scoped=true&"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationComponent.vue?vue&type=style&index=0&id=343fd0b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fd0b6",
  null
  
)

export default component.exports